import React, { useEffect, useState } from 'react';
import { Card, Form, Space, Radio, Button, Tooltip } from 'antd';

import { formItemLayout } from '../Common';
import { isEmpty } from 'script/common';

const AppHeader = ({ t, settingKey, onSave, alertMessage, settingData }) => {
	const [form] = Form.useForm();
	const [initialValues, setInitialValues] = useState({});

	useEffect(() => {
		const updatedValues = settingKey.keyList.reduce((result, item) => {
			result[item.value] = { value: settingData[item.value] !== undefined ? settingData[item.value] : true };
			return result;
		}, {});
		setInitialValues({ data: updatedValues });
		form.setFieldsValue({ data: updatedValues });
	}, [settingData, settingKey.keyList, form]);


	const onFinish = (values) => {
		let value = [];

		settingKey.keyList.forEach((item) => {
			const selectedValue = values.data[item.value]?.value;
			value.push({
				key: item.value,
				value: selectedValue
			});
		});

		onSave(value);
	}

	return (
		<Form {...formItemLayout} form={form} onFinish={onFinish} initialValues={initialValues}>
			<Tooltip title={t('setting.tooltipcontent.appHeader.label')} placement="leftTop">
				<Card title={t(settingKey.key)} key={settingKey.key} name={['settingKey.key']} style={{ margin: 20 }}>
					{settingKey.keyList && settingKey.keyList.length > 0 ? (
						settingKey.keyList.map((item) => (
							<Card type="inner" key={item.key} title={t(item.key)} style={{ margin: 20 }}>
								<Form.Item
									name={['data', item.value, 'value']}
									rules={[{ required: true, message: 'Please input value!' }]}
								>
									<Radio.Group>
										<Radio value={true}>{t('settings.show')}</Radio>
										<Radio value={false}>{t('settings.hide')}</Radio>
									</Radio.Group>
								</Form.Item>
							</Card>
						))
					) : (
						<p>No settingHeaders available</p>  // settingHeader가 없을 때 표시
					)}
					<Space style={{ float: 'right', margin: 20 }}>
						<Button type="primary" htmlType="submit" className="btn_text_b">{t('user.account.save')}</Button>
					</Space>
				</Card>
			</Tooltip>
		</Form >
	);
};

export default AppHeader;